import { createSelector } from 'reselect';
import { prop, equals } from 'ramda';

import modes from '../modes';

export const getGlobal = prop('global');

export const getToken = createSelector(
  getGlobal,
  prop('token'),
);

export const getSession = createSelector(
  getGlobal,
  prop('session'),
);

export const hasTechnicalError = createSelector(
  getGlobal,
  prop('hasTechnicalError'),
);

export const getPhoneCountry = createSelector(
  getGlobal,
  prop('phoneCountry'),
);

export const getAffiliate = createSelector(
  getGlobal,
  prop('affiliate'),
);

export const getMode = createSelector(
  getGlobal,
  prop('mode'),
);

export const getIsHighwayMode = createSelector(
  getMode,
  equals(modes.HIGHWAY),
);

export const getIsMultiChannelMode = createSelector(
  getMode,
  equals(modes.MULTI_CHANNEL),
);

export const getIsClaimTimeline = createSelector(
  getMode,
  equals(modes.CLAIM_TIMELINE),
);

export const getIsTrackMode = createSelector(
  getMode,
  equals(modes.TRACK),
);

export const getIsLocationOnlyMode = createSelector(
  getMode,
  equals(modes.LOCATION_ONLY),
);

export const getIsGarageDestinationMode = createSelector(
  getMode,
  equals(modes.GARAGE_DESTINATION),
);

export const getIsRentalCarMode = createSelector(
  getMode,
  equals(modes.RENTAL_CAR),
);

export const getAffiliateCode = createSelector(
  getAffiliate,
  prop('code'),
);

export const getSessionContext = createSelector(
  getGlobal,
  prop('sessionContext'),
);

export const isNewSession = createSelector(
  getSessionContext,
  prop('new'),
);

export const isApiSession = createSelector(
  getSessionContext,
  prop('api'),
);

export const isEmbed = createSelector(
  getGlobal,
  prop('isEmbed'),
);

export const getProviderArrival = createSelector(
  getGlobal,
  prop('providerArrival'),
);

export const getTimedout = createSelector(
  getSessionContext,
  prop('timedout'),
);

export const getGoogleMapsKey = createSelector(
  getGlobal,
  prop('googleMapsKey'),
);

export const getMapboxKey = createSelector(
  getGlobal,
  prop('mapboxKey'),
);

export const getGoogleRecaptchaSiteKey = createSelector(
  getGlobal,
  prop('googleRecaptchaSiteKey'),
);

export const getOptionalCookies = createSelector(
  getGlobal,
  prop('optionalCookies'),
);

export const getNpsAnswer = createSelector(
  getGlobal,
  prop('npsAnswer'),
);
